// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"132":"forms","274":"one-signal","802":"processing","869":"viewer","884":"admin"}[chunkId] + "." + {"132":"b949b03c","274":"257ef261","802":"e54c9207","869":"071cead7","884":"4b3a59f0"}[chunkId] + ".css";
};